import { render, staticRenderFns } from "./ProductCategoryAdd.vue?vue&type=template&id=2332c765&scoped=true&"
import script from "./ProductCategoryAdd.vue?vue&type=script&lang=js&"
export * from "./ProductCategoryAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2332c765",
  null
  
)

export default component.exports